import { createContext, useContext } from "react";

type MarkDirty = () => void;

const DialogDirtyContext = createContext<MarkDirty | undefined>(undefined);

export function useMarkDialogDirty(): MarkDirty | undefined {
  return useContext(DialogDirtyContext);
}

export { DialogDirtyContext };
